module.exports = {
  Controller: require("./controller"),
  NES: require("./nes")
};



//////////////////
// WEBPACK FOOTER
// ./src/index.js
// module id = 3
// module chunks = 0 1